import axios from 'axios';
import { useHistory } from 'react-router-dom';

export const login = async (data: any) => {
  let returnData: any;
  await axios.post('/api/auth/login', data).then((res) => {
    console.log('------RES', res);
    returnData = res;
  });
  console.log(returnData);
  return returnData;
};

export const verifyLoginOtp = (data: any) => {
  console.log('verify otp 1');
  return axios.post('/api/auth/verify-login-otp', data);
  // let returnData: any;
  // returnData = await axios.post('/api/auth/verify-login-otp', data);
  // .then((res) => {
  //   console.log('------RES', res);
  //   returnData = res;
  // });

  // console.log('Verify otp res :: ', returnData);
  // return returnData;
};

export const getCountryList = async () => {
  let returnData: any;
  await axios.get('/api/auth/countries').then((res) => {
    console.log('the country list is :', res.data);
    sessionStorage.setItem('countryList', res.data);
    returnData = res;
  });
  return returnData;
};

export const resendOtp = async (data: any) => {
  let returnData: any;
  await axios.post('/api/auth/resend-login-otp', data).then((res) => {
    returnData = res;
  });
  return returnData;
};

export const isCaptchaRequired = async (data: any) => {
  let returnData: any;
  await axios.post('/api/auth/is-captcha-req', data).then((res) => {
    returnData = res;
  });
  return returnData;
};

export const getCaptchaKey = async () => {
  let returnData: any;
  await axios.get('/api/auth/captcha-key').then((res) => {
    returnData = res;
  });
  return returnData;
};

export const verify2faPassword = async (data: any) => {
  let returnData: any;
  await axios.post('/api/auth/2fa/verify-password', data).then((res) => {
    returnData = res;
  });
  return returnData;
};

export const checkIvrStatus = async (data: any) => {
  let returnData: any;
  await axios.post('/api/auth/2fa/ivr-status', data).then((res) => {
    returnData = res;
  });
  console.log('returnData )) ', returnData.data.data);

  if (!returnData.data.data) {
    console.log('redirect to phone number page');
    // history.push('/phoneNumber');
    window.location.href = '/phoneNumber';
  }
  return returnData;
};

export const triggerIvr = async (data: any) => {
  let returnData: any;
  await axios.post('/api/auth/2fa/trigger-ivr', data).then((res) => {
    returnData = res;
  });
  return returnData;
};

export const sendResetPasswordLink = async (data: any) => {
  let returnData: any;
  await axios
    .post('/api/auth/2fa/send-reset-password-link', data)
    .then((res) => {
      returnData = res;
    });
  return returnData;
};
